/* eslint-disable */
import { WidgetInstance } from 'friendly-challenge'

function initCaptcha() {
  window.addEventListener('load', function (e) {
    const elementTag = document.querySelector('#friendly-captcha')
    elementTag.classList.add('frc-captcha')

    const doneCallback = (solution) => {
      elementTag.addEventListener('frcEvent', function(e) { e.solution })
      const frcEvent = new CustomEvent('frcEvent', {
        detail: {
          result: solution,
        },
      })
      elementTag.dispatchEvent(frcEvent)
    }

    const errorCallback = () => {
      elementTag.addEventListener('frcEvent', function(e) { e })
      const frcEvent = new CustomEvent('frcEvent', {
        detail: {
          result: 'ERROR',
        },
      })
      elementTag.dispatchEvent(frcEvent)
    }

    const options = {
      doneCallback,
      errorCallback,
      puzzleEndpoint: 'https://eu-api.friendlycaptcha.eu/api/v1/puzzle',
      sitekey: process.env.FRCTOKEN || 'FCMQR6FVUFQ66I16',
    }

    const widget = new WidgetInstance(elementTag, options)
  })
}

export { initCaptcha }
